import { render, staticRenderFns } from "./CaseGuaranteedConfig.vue?vue&type=template&id=54ce36a9&scoped=true&"
import script from "./CaseGuaranteedConfig.vue?vue&type=script&lang=js&"
export * from "./CaseGuaranteedConfig.vue?vue&type=script&lang=js&"
import style0 from "./CaseGuaranteedConfig.vue?vue&type=style&index=0&id=54ce36a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce36a9",
  null
  
)

export default component.exports